import React from "react";
import api from "../../api";


function Claims() {
      return (
    <h1>Claims</h1>
      )
    }
    export default Claims;